import api from './api'
import { User, UpdateUserDto } from '../types/User'

export const userService = {
  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/api/users/me')
    return response.data
  },

  async updateProfile(updates: UpdateUserDto): Promise<User> {
    const response = await api.put<User>('/api/users/me', updates)
    return response.data
  }
}
